import { differenceInMinutes, parse } from "date-fns";


export class TimeNegotiationValidate {

  static validate(negotiation: any): string {
    // Verifica se a negociação possui data de término
    if (!negotiation || !negotiation.data_fim) {
      return 'Data de término não definida';
    }

    // Formato de data esperado
    const format = 'yyyy-MM-dd HH:mm:ss';

    // Data de término da negociação
    const fim = parse(negotiation.data_fim, format, new Date());

    // Calcula a diferença em minutos entre a data de término e a data atual
    const difference = differenceInMinutes(fim, new Date());

    // Variável para armazenar o tempo restante formatado
    let tempoRestante = '';

    // Se ainda há tempo restante
    if (difference > 0) {
      // Calcula horas e minutos restantes
      const horasRestantes = Math.floor(difference / 60);
      const minutosRestantes = difference % 60;

      // Se tiver mais de 23 horas, mostra em dias
      if (horasRestantes > 23) {
        const diasRestantes = Math.floor(horasRestantes / 24);
        const horasRemanescentes = horasRestantes % 24;

        if (horasRemanescentes === 0) {
          tempoRestante = `Restam ${diasRestantes} dia${diasRestantes > 1 ? 's' : ''}`;
        } else {
          tempoRestante = `Restam ${diasRestantes} dia${diasRestantes > 1 ? 's' : ''} e ${horasRemanescentes}h`;
        }
      } else {
        // Formata o tempo restante em horas e minutos
        tempoRestante = `Restam ${horasRestantes}:${minutosRestantes.toString().padStart(2, '0')}h`;
      }
    } else {
      // Define a negociação como expirada
      tempoRestante = 'negociacao_expirada';
    }

    return tempoRestante;
  }

  static validateWithTranslate(negotiation: any): { key: string; params?: any } {
    if (!negotiation || !negotiation.data_fim) {
      return { key: 'data_termino_nao_definida' };
    }

    const format = 'yyyy-MM-dd HH:mm:ss';
    const fim = parse(negotiation.data_fim, format, new Date());
    const difference = differenceInMinutes(fim, new Date());

    if (difference > 0) {
      const horasRestantes = Math.floor(difference / 60);
      const minutosRestantes = difference % 60;

      if (horasRestantes > 23) {
        const diasRestantes = Math.floor(horasRestantes / 24);
        const horasRemanescentes = horasRestantes % 24;

        if (horasRemanescentes === 0) {
          if (diasRestantes > 0) {
            return { key: 'restam_dias', params: { dias: diasRestantes } };
          }
          return { key: 'restam_dia', params: { dias: diasRestantes } };
        } else {
          if (diasRestantes > 1) {
            return {
              key: 'restam_dias_e_horas',
              params: { dias: diasRestantes, horas: horasRemanescentes },
            };
          }
          return {
            key: 'restam_dia_e_horas',
            params: { dias: diasRestantes, horas: horasRemanescentes },
          };
        }
      } else {
        return {
          key: 'restam_horas_minutos',
          params: {
            horas: horasRestantes,
            minutos: minutosRestantes.toString().padStart(2, '0'),
          },
        };
      }
    } else {
      return { key: 'negociacao_expirada' };
    }
  }
}
